const en = {
  // Navigation
  home: 'Home',
  rconHacking: 'RCON Audit',
  accountChecker: 'Account Checker',
  ddosTesting: 'DDoS Testing',
  servers: 'Servers',
  serverDataExtraction: 'Data Extraction',
  bots: 'Bots',
  secret: 'Secret',
  account: 'Account',
  terms: 'Terms',

  // Home Page
  socialCommunities: 'Communities',
  telegramCommunity: 'Telegram Channel',
  telegramLeaksDesc: 'Exclusive leaks of private software, methods and scripts. Be the first to know about updates.',
  discordCommunity: 'Discord Server',
  discordLeaksDesc: 'Discussion of security testing methods, help for beginners and direct communication with developers.',
  joinCommunity: 'Join',
  joinNow: 'Join Now',
  openLink: 'Open Link',
  serverTestTitle: 'Server Test',
  serverTestDescription: 'Connect to a server below to start comprehensive security testing and discover vulnerabilities',
  serverTestPlaceholder: '127.0.0.1:25565',
  serverTestButton: 'Test',
  serverHackingTools: 'Security Testing Tools',
  botConnectionTools: 'Bot Testing Tools',
  additionalTestingTools: 'Additional Testing Tools',
  toolsAvailable: 'tools available',
  recentTestedServers: 'Recent Tested Servers',
  noRecentServersFound: 'No recent servers found',
  players: 'players',
  tested: 'Tested',
  proofOfEffectiveness: 'Proof of Effectiveness',
  noProofsAvailable: 'No proofs available',
  views: 'views',
  totalServersTested: 'Total Servers Tested',
  thisWeek: 'this week',
  vulnerabilitiesFound: 'Vulnerabilities Found',
  critical: 'Critical',
  accountsChecked: 'Accounts Checked',
  valid: 'Valid',
  activeUsers: 'Active Users',
  premium: 'Premium',
  allTools: 'Available tools',

  // Authentication
  login: 'Login',
  loggingIn: 'Signing in...',
  register: 'Register',
  logout: 'Logout',
  loginWithGoogle: 'Login with Google',
  loginRequired: 'Authorization Required',
  loginRequiredDescription: 'Please log in to your account to view plans, referral program, and API keys.',
  email: 'Email',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  forgotPassword: 'Forgot Password?',
  resetPassword: 'Reset Password',
  myAccount: 'My Account',

  // Common
  loading: 'Loading...',
  error: 'Error',
  success: 'Success',
  cancel: 'Cancel',
  confirm: 'Confirm',
  close: 'Close',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  searchModules: 'Search modules...',
  noResultsFound: 'No results found',
  notifications: 'Notifications',
  noNewNotifications: 'No new notifications',
  viewAll: 'View All',
  couldNotLoadProofVideos: 'Could not load proof videos',
  notAuthenticated: 'Not authenticated',
  quickLinks: 'Quick Links',
  pricing: 'Pricing',
  blog: 'Blog',
  communityAndSupport: 'Community & Support',
  termsOfService: 'Terms of Service',
  privacyPolicy: 'Privacy Policy',
  supportCenter: 'Support Center',
  footerDescription: 'Advanced Minecraft server security testing suite. Discover vulnerabilities before they\'re exploited.',
  allRightsReserved: 'All rights reserved.',
  user: 'User',
  free: 'Free',
  couldNotProcessPaymentMethod: 'Could not process payment method',
  couldNotProcessPaymentInitiation: 'Could not process payment initiation. Please try again.',
  unknownErrorOccurred: 'An unknown error occurred',
  pleaseLogInToViewAccountDetails: 'Please log in to view account details',
  connectingToServer: 'Connecting to server...',
  failedToProcessPaymentInitiation: 'Failed to process payment initiation. Please try again.',
  couldNotLoadAccountData: 'Could not load account data. Please try refreshing.',
  processing: 'Processing...',
  couldNotFindDetailsForCurrentPlan: 'Could not find details for the current plan to extend.',
  iAcceptTerms: 'I accept the terms of service',
  paymentWindowOpened: 'Please complete the payment in the opened window.',
  openPaymentPage: 'Payment Page',
  waitingForConfirmation: 'Waiting for funds...',
  awaitingPaymentConfirmation: 'Awaiting Payment Confirmation',
  longWaitQuestion: 'Any questions or delays? Contact our support email',

  // Account
  accountOverview: 'Account Overview',
  subscription: 'Subscription',
  paymentHistory: 'Payment History',
  paymentMethods: 'Payment Methods',
  manageSubscription: 'Manage Subscription',
  daysLeft: 'days left',
  current: 'Current',
  member: 'Member',
  youHaveAccessToAllFeatures: 'You have access to all features!',
  unlockMoreFeaturesByUpgradingToProfessional: 'Unlock more features by upgrading to Professional',
  unlockMoreFeaturesByUpgradingToPremium: 'Unlock more features by upgrading to Premium',
  upgradeToAPaidPlanToUnlockMoreFeatures: 'Upgrade to a paid plan to unlock more features.',
  serversTested: 'Servers Tested',
  bonusPoints: 'Bonus Points',
  testsRemaining: 'Tests Remaining',
  resetsInDays: 'Resets in {{days}} days',
  noLimit: 'No limit',
  dailyLimit: 'Daily limit',
  noReceipt: 'No receipt',
  successfulHacks: 'Successful Audits',
  successRate: 'success rate',
  currentSubscription: 'Current Subscription',
  active: 'Active',
  plan: 'Plan',
  billedMonthly: 'Billed every 6 months',
  renewsOn: 'Renews on',
  changePlan: 'Change Plan',
  extendSubscription: 'Extend Subscription',
  status: 'Status',
  price: 'Price',
  subscriptionId: 'Subscription ID',
  timeRemaining: 'Time remaining',
  daysUsed: 'days used',
  daysTotal: 'days total',
  planFeatures: 'Plan Features',
  availablePlans: 'Available Plans',
  options: 'options',
  noPlansAvailable: 'No plans available.',
  currentPlan: 'Current Plan',
  freeTier: 'Free Tier',
  upgradeTo: 'Upgrade to',
  records: 'records',
  date: 'Date',
  description: 'Description',
  amount: 'Amount',
  receipt: 'Receipt',
  status: 'Status',
  method: 'Method',
  noPaymentHistoryFound: 'No payment history found',
  unlockAdvancedHackingTools: 'Unlock Advanced Security Tools',
  upgradeToProfessionalPlanToAccessAllServerTestingTools: 'Upgrade to Professional plan to access all server testing tools and advanced security assessment methods.',
  upgradeToProfessional: 'Upgrade to Professional',
  developerTools: 'Developer Tools',
  noApiKeys: 'You have no API keys yet',
  referrals: 'Referrals',

  // Referrals
  referralSystem: 'Referral System',
  myReferralLinks: 'My Referral Links',
  createReferralLink: 'Create Referral Link',
  referralLinkName: 'Link Name (e.g., YouTube)',
  copyLink: 'Copy Link',
  registrations: 'Registrations',
  earnings: 'Earnings',
  referralEarnings: 'Referral Earnings',
  purchases: 'Purchases',
  noReferralLinksYet: 'You have no referral links yet',
  referralNamePlaceholder: 'Enter link name',
  noReferrals: 'You have no referrals yet',
  confirmDeleteReferral: 'Are you sure you want to delete this referral link?',
  referralBonus: 'Referral Bonus',
  inviteFriendsAndEarn: 'Invite friends and earn 10% of their purchases to your bonus balance!',

  // Plan descriptions
  freePlanDescription: 'Basic access to core features',
  vipPlanDescription: 'Enhanced features and priority support',
  premiumPlanDescription: 'Advanced tools and increased limits',
  professionalPlanDescription: 'Full access to all features and tools',
  apiPlanDescription: 'Access to REST API for programmatic integration',

  // Plan features
  basicFeature: 'Basic Feature',
  advancedFeature: 'Advanced Feature',
  professionalFeature: 'Professional Feature',

  apiKeysManagement: "API Keys Management",
  manageYourApiKeysForProgrammaticAccess: "Manage your API keys for programmatic access",
  createNewKey: "Create New Key",
  noApiKeysYet: "No API Keys Yet",
  createYourFirstApiKeyToStartIntegrating: "Create your first API key to start integrating with our services",
  createFirstKey: "Create First Key",
  apiKeyUsageGuidelines: "API Key Usage Guidelines",
  keepYourApiKeysSecure: "Keep your API keys secure and never commit them to version control",
  neverShareKeysPublicly: "Never share your keys publicly or in client-side code",
  regenerateKeysIfCompromised: "Regenerate keys immediately if you suspect they've been compromised",
  deactivateUnusedKeys: "Deactivate unused keys to maintain security",
  apiDocs: "API Docs",
  createNewApiKey: "Create New API Key",
  giveYourKeyADescriptiveName: "Give your key a descriptive name",
  keyName: "Key Name",
  enterKeyName: "Enter key name",
  exampleProductionServer: "e.g., Production Server",
  create: "Create",
  name: "Name",
  actions: "Actions",
  copyToClipboard: "Copy to clipboard",
  created: "Created",
  lastUsed: "Last used",
  never: "Never",
  requests: "Requests",
  deactivate: "Deactivate",
  activate: "Activate",
  delete: "Delete",
  confirmDeleteApiKey: "Are you sure you want to delete this API key?",
  thisActionCannotBeUndone: "This action cannot be undone. Applications using this key will lose access.",
  apiKeyOperationFailed: "API key operation failed",
  apiKeyNamePlaceholder: "Key name (e.g., My App)",
  active: "Active",
  inactive: "Inactive",

  // API Documentation
  apiDocumentation: "API Documentation",
  apiDocumentationDescription: "Learn how to use our REST API to integrate StormHack services into your applications",
  gettingStarted: "Getting Started",
  apiGettingStartedDescription: "To use the StormHack API, you'll need an API key which can be generated in your account settings. All API requests must be made over HTTPS and include your API key in the Authorization header.",
  apiBaseUrl: "Base URL",
  authentication: "Authentication",
  apiAuthenticationDescription: "Authenticate your API requests by including your API key in the Authorization header of your requests.",
  headers: "Headers",
  rateLimits: "Rate Limits",
  apiRateLimitsDescription: "API requests are rate limited based on your subscription plan to ensure fair usage and service stability.",
  freePlan: "Free Plan",
  apiPlan: "API Plan",
  professionalPlan: "Professional Plan",
  endpoints: "Endpoints",
  serverInfoEndpointDescription: "Retrieve information about a Minecraft server including version, player count, and MOTD.",
  accountCheckerEndpointDescription: "Check if a Minecraft username has associated credentials in our database.",
  exampleRequest: "Example Request",
  exampleResponse: "Example Response",
  errorHandling: "Error Handling",
  apiErrorHandlingDescription: "The API uses standard HTTP status codes to indicate the success or failure of requests. All responses are returned in JSON format.",
  exampleError: "Example Error Response",

  // Status
  connected: 'Connected',
  disconnected: 'Disconnected',
  connecting: 'Connecting...',

  // Plans
  free: 'Free',
  basic: 'Basic',
  premium: 'Premium',
  enterprise: 'Enterprise',

  // Features
  feature1: 'Basic Feature',
  feature2: 'Advanced Feature',
  feature3: 'Professional Feature',

  // Months
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',

  // DDoS Testing
  ddosModuleTitle: 'DDOS TESTING MODULE',
  ddosServerStress: 'Server Stress & Resilience',
  ddosAssessment: 'Assessment',
  ddosDescription: 'Analyze server resilience against common DDoS vectors. Connect to a target below to begin. Ensure authorization before proceeding.',
  ddosAttackTypeSelection: 'Attack Type Selection',
  ddosMethodsAvailable: '2 methods available',
  ddosBotAttack: 'Bot DDoS Attack',
  ddosBotAttackDescription: 'Multiple bot clients connect to overload server capacity',
  ddosPacketAttack: 'Packet DDoS Attack',
  ddosPacketAttackDescription: 'Send large volumes of malformed packets to overload network',
  ddosEffectiveness: 'Effectiveness',
  ddosDetectionRisk: 'Detection Risk',
  ddosResourceUsage: 'Resource Usage',
  ddosVeryHigh: 'Very High',
  ddosMedium: 'Medium',
  ddosHigh: 'High',
  ddosAttackConfiguration: 'Attack Configuration',
  ddosPacketAttackMethod: 'Packet Attack Method',
  ddosBotAttackMethod: 'Bot Attack Method',
  ddosAttackIntensity: 'Attack Intensity',
  ddosLow: 'Low',
  ddosThreadCount: 'Thread Count',
  ddosDuration: 'Duration',
  ddosSeconds: 'Seconds',
  ddosMinutes: 'Minutes',
  ddosHours: 'Hours',
  ddosShowAdvancedOptions: 'Show Advanced Options',
  ddosAdvancedOptions: 'Advanced options will appear here.',
  ddosStartTest: 'Start DDoS Test',
  ddosStopTest: 'Stop DDoS Test',
  ddosProcessing: 'Processing...',
  ddosAttackMonitoring: 'Attack Monitoring',
  ddosActive: 'Active',
  ddosNotActive: 'Not Active',
  ddosPacketsSent: 'Packets Sent',
  ddosDataSent: 'Data Sent',
  ddosTargetPing: 'Target Ping',
  ddosTargetStatus: 'Target Status',
  ddosOnline: 'Online',
  ddosRunning: 'Running',
  ddosStressed: 'Stressed',
  ddosLagging: 'Lagging',
  ddosOffline: 'Offline',
  ddosCrashed: 'Crashed',
  ddosTrafficRate: 'Traffic Rate',
  ddosPacketsPerSec: 'Packets/sec',
  ddosBandwidth: 'Bandwidth',
  ddosCpuUsage: 'Est. CPU Usage',
  ddosServerResponse: 'Server Response',
  ddosResponseTime: 'Response Time',
  ddosTimeoutRate: 'Timeout Rate',
  ddosPlayersOnline: 'Players Online',
  ddosAttackCompleted: 'Attack completed. View results below.',
  ddosAttackError: 'Attack ended due to an error.',
  ddosStartVisualization: 'Start attack to see network visualization',
  ddosSynFlood: 'SYN Flood',
  ddosUdpFlood: 'UDP Flood',
  ddosPingFlood: 'Ping Flood (ICMP)',
  ddosTcpBypass: 'TCP Bypass',
  ddosConnectionFlood: 'Connection Flood',
  ddosChatSpam: 'Chat Spam / Flood',
  ddosJoinFlood: 'Join/Leave Flood',
  ddosLagExploit: 'Lag Exploit Bot',
  ddosAttackDurationTip: 'Attack Duration',
  ddosAttackDurationDesc: 'Short tests (30-60 seconds) are usually sufficient to assess vulnerabilities without causing extended downtime. Longer tests increase detection risk and may trigger automatic mitigation systems.',
  ddosUseVpn: 'Use VPN',
  ddosUseVpnDesc: 'Always use a VPN when performing DDoS testing to protect your identity and avoid potential IP bans. Rotate VPN endpoints between tests to avoid blacklisting.',
  ddosLegalConsiderations: 'Legal Considerations',
  ddosLegalConsiderationsDesc: 'DDoS testing without explicit permission is illegal in most jurisdictions and could result in serious legal consequences. Always obtain written permission from server owners before conducting tests.',
  ddosConnectToServer: 'Cannot configure DDoS attack. Connect to an online server first.',
  ddosAttackLog: 'DDoS Attack Log',
  ddosClearLog: 'Clear Log',
  rememberToUseThisToolResponsibly: 'Remember to use this tool responsibly.',
  ddosProtectionAnalysis: 'DDoS Protection Analysis',
  ddosDetectedProtection: 'Detected Protection',
  ddosNoProtectionData: 'No protection data available',
  ddosUnknownProtection: 'Unknown Protection',
  ddosNoDescription: 'No description',
  ddosRecommendations: 'Recommendations',
  commentRecommendations: 'Recommendations',
  ddosNoRecommendations: 'No recommendations available',
  ddosRecommendation: 'Recommendation',
  ddosNoDetailsProvided: 'No details provided.',
  ddosTestResultsHistory: 'Test Results & History',
  ddosNoTestResults: 'No test results available yet. Run a test to see results here.',
  ddosSuccessful: 'Successful',
  ddosFailed: 'Failed / Ineffective',
  ddosLastTestResult: 'Last Test Result',
  ddosTestSummary: 'Test Summary ({{timestamp}})',
  ddosTestType: 'Type:',
  ddosDuration: 'Duration:',
  ddosShowLess: 'Show Less',
  ddosShowDetails: 'Show Details',
  ddosOverallResult: 'Overall Result',
  ddosTargetStatusAfter: 'Target Status After',
  ddosUnknown: 'Unknown',
  ddosSummaryMessage: 'Summary Message',
  ddosNoSummary: 'No summary provided.',
  ddosAttackMetrics: 'Attack Metrics',
  ddosMaxPackets: 'Max Packets/s',
  ddosAvgBandwidth: 'Avg Bandwidth',
  ddosTotalDataSent: 'Total Data Sent',
  ddosServerResponse: 'Server Response',
  ddosHighestPing: 'Highest Ping',
  ddosTimeouts: 'Timeouts',
  ddosLowestPlayers: 'Lowest Players',
  ddosVulnerabilitiesFound: 'Vulnerabilities Found',
  ddosExportDetails: 'Export Details',
  ddosTargetServer: 'Target Server',
  ddosConnection: 'Connection',
  ddosEnterTargetServer: 'Enter the IP address of the server you want to perform DDoS testing on. Ensure you have permission before proceeding.',
  ddosTargetServerPlaceholder: 'Target Server IP (e.g., mc.server.com)',
  ddosConnecting: 'Connecting...',
  ddosConnectToServer: 'Connect to Server',

  // RCON Hacking
  rconModuleTitle: 'RCON AUDIT MODULE',
  rconRemoteConsole: 'Remote Console',
  rconAccess: 'Access',
  rconDescription: 'Scan for open RCON ports and attempt to brute-force passwords using comprehensive wordlists. Connect to a server below.',
  rconCommonPorts: 'Common RCON Ports',
  rconStandardPort: 'Standard Minecraft RCON port',
  rconUnusualPort: 'Minecraft Server Port (unusual for RCON)',
  rconHighConfidence: 'High Confidence',
  rconMediumConfidence: 'Medium Confidence',
  rconResponseTime: 'Response Time',
  rconProtocolVersion: 'Protocol Version',
  rconAuthentication: 'Authentication',
  rconCrackPassword: 'Crack Password',
  rconScannerConfig: 'Scanner Config',
  rconCrackerConfig: 'Cracker Config',
  rconScanMode: 'Scan Mode',
  rconDefinesPortRange: 'Defines port range',
  rconFastMode: 'Fast (Common: ~25700-30000)',
  rconMiddleMode: 'Middle (Wider: ~10000-40000)',
  rconFullMode: 'Full (All: 1024-65535)',
  rconScanThreads: 'Threads (Scan)',
  rconLow: 'Low',
  rconMedium: 'Medium',
  rconHigh: 'High',
  rconScanTimeout: 'Scan Timeout (ms)',
  rconPasswordDatabase: 'Password Database',
  rconLoadingBases: 'Loading bases...',
  rconWaitingPasswordBase: 'Waiting for password base list from server...',
  rconThreadsCrack: 'Threads (Crack)',
  rconRequestDelay: 'Request Delay (Crack)',
  rconFast: 'Fast',
  rconBalanced: 'Balanced',
  rconStealthy: 'Stealthy',
  rconProcessing: 'Processing...',
  rconAccessGranted: 'Access Granted',
  rconCrackPort: 'Crack Port',
  rconStartRconCrack: 'Start Rcon crack',
  rconSelectPasswordDatabase: 'Select a password database',
  rconPortScanner: 'RCON Port Scanner',
  rconRunning: 'Running...',
  rconReady: 'Ready',
  rconStopScan: 'Stop Scan',
  rconStartScan: 'Start Scan',
  rconScanningPortRange: 'Scanning port range: 1000-30000',
  rconComplete: 'Complete',
  rconPortsScanned: 'Ports Scanned',
  rconOpenPorts: 'Open Ports',
  rconRconCandidates: 'RCON Candidates',
  rconStopScanButton: 'Stop Scan',
  rconClearResults: 'Clear Results',
  rconContinuePasswordCracker: 'Continue to Password Cracker',
  rconPasswordCracking: 'Password Cracking',
  rconLockedUntilPortSelected: 'Locked until port is selected',
  rconSelectDetectedPort: 'Select a detected RCON port to begin password cracking',
  rconStartPasswordCracker: 'Start Password Cracker',
  rconConnectDirectly: 'Connect Directly (If RCON Known)',
  rconRconPort: 'RCON Port',
  rconRconPassword: 'RCON Password',
  rconConnect: 'Connect',
  rconScanPort: 'Scan Port',
  rconCrackPasswordStep: 'Crack Password',
  rconRconConsole: 'RCON Console',
  rconDetectedRconPorts: 'Detected RCON Ports',
  rconCommonRconPorts: 'Common RCON Ports',
  rconPasswordStrategy: 'Password Strategy',
  rconPatienceIsKey: 'Patience Is Key',
  rconHackingTips: 'RCON Audit Tips',
  rconProTips: 'Pro Tips',
  rconStandardPortTip: 'Most servers use port 25575 for RCON by default. Also check ports 25565+10 pattern.',
  rconPasswordStrategyTip: 'Start with server name variations, then common Minecraft passwords, then standard wordlists.',
  rconPatienceTip: 'RCON cracking can take time. Higher delay values reduce detection risk but make cracking slower.',
  rconStandardPortDetails: 'Standard RCON port is typically 25575, but some servers use variations like 25576, 25585, or even non-standard ports for security.',
  rconPasswordOrder: 'Effective password guessing order: 1) Server name variations 2) "minecraft", "password", "admin" 3) Top 1000 passwords 4) Full wordlist',
  rconDelaySettings: 'Recommended delay settings: 50ms for fast networks, 150-300ms for balanced approach, 500ms+ for stealthy auditing',
  rconNote: 'Note: RCON testing should only be performed on servers you own or have permission to test.',
  rconLegalDisclaimer: 'Legal Disclaimer',
  rconEthicalGuidelines: 'Ethical Guidelines',
  rconSuccessRconAccess: 'Success! RCON access granted on port',
  rconPassword: 'Password',
  rconSendCommandsConsole: 'You can now send commands via the console above.',
  rconCannotSendCommand: 'Cannot send command: RCON access not granted or not connected.',
  rconCannotConnectManually: 'Cannot connect manually: Check server connection or ongoing process.',
  rconInitiatingRconProcess: 'Initiating RCON process for',
  rconCannotStart: 'Cannot start',
  rconServerNotConnected: 'Server not connected or is offline.',
  rconWebSocketNotConnected: 'WebSocket not connected. Please wait or refresh.',
  rconProcessAlreadyRunning: 'Cannot start: Process already running.',
  rconSelectPasswordBase: 'Please select a password database before cracking.',
  rconConfigurationIncomplete: 'Configuration Incomplete',
  rconNoPasswordBases: 'No password bases loaded and none selected. Cannot start RCON process.',
  rconConfigurationError: 'Configuration Error',
  rconRequestingProcessStop: 'Requesting process stop...',
  rconNoActiveProcess: 'No active process to stop or not connected.',
  rconSelectedPort: 'Selected port',
  rconConfigureCracker: 'Configure cracker settings and click \'Crack Port\'.',
  rconPortSelected: 'Port Selected',
  rconScanCompleted: 'Port scan completed.',
  rconNoPotentialPorts: 'No potential RCON ports found.',
  rconPortScanFinished: 'Scan Finished (No Ports)',
  rconPortFoundSelectCracker: 'Port Found, Select Cracker',
  rconRconAccessGrantedTitle: 'RCON Access Granted!',
  rconUsingDefaultPasswordBase: 'Using default password base',
  rconAsNoneSelected: 'as none was explicitly selected.',
  rconPortScanInitiated: 'Port scan initiated...',
  rconPasswordCrackingInitiated: 'Password cracking initiated on port',
  rconPasswordCrackingInitiatedPort: 'Password cracking initiated (port not specified in message, current:',
  rconPasswordCrackingFinished: 'Password cracking finished on port',
  rconPasswordNotFound: 'Password not found.',
  rconCrackFinishedFailed: 'Crack Finished (Failed)',
  rconProcessStopped: 'RCON process stopped.',
  rconPortScanFinishedAwaiting: 'Port scan finished. Awaiting password crack initiation...',
  rconScanFinishedNoPorts: 'Port scan completed. No potential RCON ports found.',
  rconPasswordFound: 'Success! RCON access granted on port',
  rconConnectingRcon: 'Connecting to RCON',
  rconAttemptingManualConnect: 'Attempting manual RCON connect to',
  rconResettingRconState: 'Resetting RCON State',
  rconKeepBaseInfo: 'Keep Base Info',
  rconStateReset: 'RCON State Reset',
  rconManualInput: 'Manual Input',
  rconConfirmManualInput: 'Confirm Manual Input',
  rconPortScanCompleted: 'Port scan completed.',
  rconPortsFound: 'Potential RCON ports found.',
  rconAwaitingPasswordCrack: 'Awaiting password crack initiation...',
  rconNeutralAwaiting: 'Neutral, awaiting next step',
  rconPortScanFinishedPorts: 'Port scan finished.',
  rconPotentialRconPort: 'Potential RCON port found:',
  rconAvailablePasswordBases: 'Available password bases loaded:',
  rconFailedLoadPasswordBases: 'Failed to load password bases.',
  rconStatus: 'Status',
  rconError: 'RCON Error',
  rconCannotConfigure: 'Cannot configure RCON attack. Connect to an online server first.',
  rconProcessLog: 'RCON Process Log',
  rconClearLog: 'Clear Log',
  rconStopProcess: 'Stop Process',
  rconStopping: 'Stopping...',
  rconRconProcessLog: 'RCON Process Log',
  rconVipLimitInfo: 'Only single-threaded scanning is available with the VIP plan. Multi-threaded scanning is only available with the Professional plan.',
  musicVolume: 'Music Volume',
  muteMusic: 'Mute',
  unmuteMusic: 'Unmute',
  musicChoice: 'Music Preference',
  statsFor24h: 'Last 24 hours',
  autoplayBlocked: 'Autoplay blocked: ',
  musicStayed: 'Listen to music',
  avgTimeBeforeMute: 'Avg. listen time: ',

  // Account Checker
  accountCheckerModuleTitle: 'ACCOUNT CHECKER MODULE',
  accountCheckerCredentialFinder: 'Credential Finder',
  accountCheckerDescription: 'Enter a Minecraft username to search for matching credentials in our comprehensive database of leaked accounts.',
  accountCheckerPlaceholder: 'Enter Minecraft username',
  accountCheckerButton: 'Check Account',
  accountCheckerSearching: 'Searching...',
  accountCheckerDatabaseSelection: 'Database Selection',
  accountCheckerDatabaseAll: 'All Databases (15.3M accounts)',
  accountCheckerDatabaseRecent: 'Recent Leaks Only (2.1M accounts)',
  accountCheckerDatabaseVerified: 'Verified Accounts Only (8.7M accounts)',
  accountCheckerDatabasePremium: 'Available',
  accountCheckerSearchType: 'Search Type',
  accountCheckerSearchTypeExact: 'Exact Match',
  accountCheckerSearchTypeSimilar: 'Similar Names',
  accountCheckerMaxResults: 'Maximum Results',
  accountCheckerShowConfidence: 'Show Confidence Rating',
  accountCheckerTotalAccounts: 'Data Extracted',
  accountCheckerUniquePasswords: 'Passwords',
  accountCheckerServerSources: 'Server Sources',
  accountCheckerSuccessRate: 'Success Rate',
  accountCheckerPremiumFeaturesTitle: 'Premium Account Checker Features',
  accountCheckerPremiumFeaturesDescription: 'Upgrade to VIP to access advanced features including bulk checking, automatic verification, email checking, and more.',
  accountCheckerLearnMore: 'Learn More',
  accountCheckerUpgradeToVip: 'Upgrade to Premium',
  accountCheckerBulkChecking: 'Bulk Checking',
  accountCheckerBulkCheckingDesc: 'Check up to 1,000 accounts simultaneously with CSV import/export',
  accountCheckerLiveVerification: 'Live Verification',
  accountCheckerLiveVerificationDesc: 'Automatically verify accounts against Mojang servers',
  accountCheckerEmailMatching: 'Email Matching',
  accountCheckerEmailMatchingDesc: 'Find associated email addresses for complete account recovery',
  accountCheckerExtendedDatabase: 'Extended Database',
  accountCheckerExtendedDatabaseDesc: 'Access our premium database with 7M+ additional accounts',
  accountCheckerHowItWorksTitle: 'How It Works',
  accountCheckerHowItWorksStep1Title: 'Enter Username',
  accountCheckerHowItWorksStep1Desc: 'Enter the Minecraft username you want to check.',
  accountCheckerHowItWorksStep2Title: 'Database Search',
  accountCheckerHowItWorksStep2Desc: 'We search for credentials in our extensive leak database.',
  accountCheckerHowItWorksStep3Title: 'Get Results',
  accountCheckerHowItWorksStep3Desc: 'Receive found credentials and security information.',
  accountCheckerCredentialStuffingTitle: 'Credential Stuffing Status',
  accountCheckerCredentialStuffingActive: 'Active',
  accountCheckerCredentialStuffingBotsActive: 'Bots Active',
  accountCheckerCredentialStuffingSuccessRate: 'Success Rate',
  accountCheckerCredentialStuffingRecentFinds: 'Recent Finds',
  accountCheckerCredentialStuffingServersMonitored: 'Servers Monitored',
  accountCheckerCredentialStuffingActiveProxies: 'Active Proxies',

  // Credential Stuffing Status
  accountCheckerCredentialStuffingOffline: 'Offline',
  accountCheckerCredentialStuffingDescription: 'Advanced autonomous bot system continuously testing credentials across {{servers}} servers',
  accountCheckerCredentialStuffingHideDetails: 'Hide Technical Details',
  accountCheckerCredentialStuffingShowDetails: 'Show Technical Details',
  accountCheckerCredentialStuffingHowItWorks: 'How It Works',
  accountCheckerCredentialStuffingParsing: 'Parses popular server monitoring sites',
  accountCheckerCredentialStuffingPlayerData: 'Collects online player data',
  accountCheckerCredentialStuffingDeploying: 'Deploys bots with randomized credentials',
  accountCheckerCredentialStuffingUpdating: 'Updates database on successful attempts',
  accountCheckerCredentialStuffingCurrentActivity: 'Current Activity',
  accountCheckerCredentialStuffingServersPerHour: 'Servers/Hour',
  accountCheckerCredentialStuffingLastUpdate: 'Last Update',
  accountCheckerCredentialStuffingKeyAdvantages: 'Key Advantages',
  accountCheckerCredentialStuffingNoBcrypt: 'No BCrypt decryption needed',
  accountCheckerCredentialStuffingRealTime: 'Real-time credential validation',
  accountCheckerCredentialStuffingAutonomous: '24/7 autonomous operation',
  accountCheckerCredentialStuffingFreshDatabase: 'Fresh 2025 database integration',
  accountCheckerCredentialStuffingSystemPerformance: 'System Performance',
  accountCheckerCredentialStuffingOptimal: 'Optimal',

  // Account Results
  accountCheckerPasswordHashesDetected: 'Password Hashes Detected',
  accountCheckerPasswordHashesDetectedDesc: 'Some passwords are displayed as hashes (e.g., sha$5, md5:abcdef). These are encrypted passwords that need to be decrypted.',
  accountCheckerDecryptHashes: 'Decrypt hashes at hashes.com',
  accountCheckerDismiss: 'Dismiss',
  accountCheckerSearchError: 'Search Error',
  accountCheckerTryAnotherSearch: 'Try Another Search',
  accountCheckerSearchingFor: 'Searching for',
  accountCheckerNoResultsFound: 'No results found for',
  accountCheckerTryDifferentUsername: 'Try a different username or adjust search options',
  accountCheckerEnterUsername: 'Enter a username to start searching',
  accountCheckerPopularSearches: 'Popular searches:',
  accountCheckerConfidence: 'Confidence',
  accountCheckerHashedPassword: 'This is a hashed password',
  accountCheckerHash: 'Hash',
  accountCheckerCopyCredentials: 'Copy Credentials',
  accountCheckerSource: 'Source',
  accountCheckerLastVerified: 'Last Verified',
  accountCheckerPreparingResults: 'Preparing search results area...',
  accountCheckerSearchResults: 'Account Search Results',
  accountCheckerMatchesFound: 'matches found',
  accountCheckerError: 'Error',
  accountCheckerExportResults: 'Export Results',
  accountCheckerNewSearch: 'New Search',

  // Search History
  accountCheckerRecentSearches: 'Recent Searches',
  accountCheckerNoRecentSearches: 'No recent searches',
  accountCheckerResults: 'results',
  accountCheckerViewFullHistory: 'View Full History',

  // Account Checker Page
  accountCheckerError: 'Account Check Error',
  accountCheckerModuleName: 'Account Checker',
  accountCheckerNoResultsFound: 'No results found for',
  accountCheckerFailedLoadHistory: 'Failed to load search history',
  accountCheckerConnectionLost: 'Connection lost during search',
  accountCheckerEnterUsernameError: 'Please enter a username',
  accountCheckerLoginRequired: 'Please log in to perform a search',
  accountCheckerNotConnected: 'Not connected to the server. Please wait or refresh',
  accountCheckerSearchComplete: 'Search complete. Found',
  accountCheckerResult: 'result',

  // Common terms
  accountCheckerSearching: 'Searching',

  // Server Database
  serverDatabase: 'Servers',
  availableServers: 'Available Servers',
  serverDatabaseDescription: 'Browse our database of available servers to test with instant connection. Updated every 30 minutes.',
  refreshList: 'Refresh List',
  allServers: 'All Servers',
  online: 'Online',
  popular: 'Popular',
  vulnerable: 'Vulnerable',
  moreFilters: 'More Filters',
  gridView: 'Grid View',
  listView: 'List View',
  searchServers: 'Search servers by IP, name, or tag...',
  version: 'Version',
  anyVersion: 'Any version',
  playerCount: 'Player Count',
  anySize: 'Any size',
  small: 'Small (0-100)',
  medium: 'Medium (101-1000)',
  large: 'Large (1000+)',
  lastTested: 'Last Tested',
  anyTime: 'Any time',
  lastHour: 'Last hour',
  last24Hours: 'Last 24 hours',
  last7Days: 'Last 7 days',
  last30Days: 'Last 30 days',
  noServersFound: 'No servers found matching your criteria',
  server: 'Server',
  players: 'Players',
  status: 'Status',
  actions: 'Actions',
  test: 'Test',
  connect: 'Connect',
  protected: 'Protected',
  mediumRisk: 'Medium Risk',
  ipAddress: 'IP:',
  successRate: 'Success Rate:',
  lastUpdate: 'Last Update',
  hoveredServer: 'Hovered Server',
  unlockPremium: 'Unlock Professional',
  premiumDatabaseDescription: 'Get access to our extended database with over 10,000+ vulnerable Minecraft servers and advanced filtering options.',
  upgradeToPremium: 'Upgrade to Professional',
  additionalServers: 'Additional Servers',

  // Server Data Extraction
  serverDataExtractionModule: 'SERVER DATA EXTRACTION MODULE',
  retrieveServerData: 'Retrieve Server Data',
  serverDataExtractionDescription: 'Connect to a target server below to retrieve available data like MOTD, player lists, plugins, and more.',
  extractionOptions: 'Extraction Options',
  serverInformation: 'Server Information',
  basicServerInfo: 'Basic server info, IP, version, status',
  messageOfTheDay: 'Message of the Day',
  motdWithFormatting: 'Message of the day with formatting',
  serverIcon: 'Server Icon',
  downloadServerIcon: 'Download server\'s icon (64x64)',
  playerList: 'Player List',
  onlinePlayersNames: 'Online players with names if available',
  pluginList: 'Plugin List',
  detectServerPlugins: 'Detect server plugins if exposed',
  deepScan: 'Deep Scan',
  tryAdvancedMethods: 'Try advanced methods to extract more data',
  methodTimeout: 'Method Timeout (ms)',
  adjustScanSpeed: 'Adjust scan speed',
  outputFormat: 'Output Format',
  chooseReportType: 'Choose report type',
  extractServerData: 'Extract Server Data',
  extracting: 'Extracting...',
  extractedData: 'Extracted Data',
  extractData: 'Extract Data',
  dataExtractionHistory: 'Data Extraction History',
  errorLoadingHistory: 'Error loading history',
  noExtractionHistory: 'No extraction history available',
  serverDataExtractionTips: 'Server Data Extraction Tips',
  playerSampling: 'Player Sampling',
  playerSamplingDescription: 'Many servers only send a sample of online players. Deep Scan might reveal more.',
  pluginDetection: 'Plugin Detection',
  pluginDetectionDescription: 'Plugin lists are often hidden. Success depends on server configuration.',
  timeoutSettings: 'Timeout Settings',
  timeoutSettingsDescription: 'Increase timeout for slow servers, but be cautious of security flags.',
  dataExtractionError: 'Data Extraction Error',
  dataExtractionCompleted: 'Data Extraction Completed',
  dataExtractionFailed: 'Data Extraction Failed',
  dataExtractionInProgress: 'Data Extraction In Progress',
  download: 'Download',
  copy: 'Copy',
  copyRaw: 'Copy Raw',
  serverIconTitle: 'Server Icon',
  serverInformationTitle: 'Server Information',
  playerListTitle: 'Player List',
  pluginListTitle: 'Plugin List',
  motdTitle: 'Message of the Day',
  rawData: 'Raw Data',
  rawDataJson: 'Raw Data (JSON)',
  downloadAllData: 'Download All Data (JSON)',
  errorLoadingPlayers: 'Error loading players',
  noPlayerData: 'No player data',
  errorLoadingPlugins: 'Error loading plugins',
  noPluginsDetected: 'No plugins detected',
  errorLoadingMotd: 'Error loading MOTD',
  motdNotAvailable: 'MOTD N/A',
  noDataAvailable: 'No data available',
  connectToServerToViewData: 'Connect to a server to view extracted data.',
  pleaseWait: 'Please wait.',
  extractDataFirst: 'Extract server data first.',
  errorLoadingIcon: 'Error loading icon',
  iconNotAvailable: 'Icon N/A',
  ipAddressLabel: 'IP Address',
  port: 'Port',
  status: 'Status',
  version: 'Version',
  playersOnline: 'Players Online',
  ping: 'Ping',
  onlinePlayers: 'Online Players',
  pluginListDetected: 'detected',
  motd: 'MOTD',
  raw: 'Raw',
  info: 'Info',
  icon: 'Icon',
  players: 'Players',
  plugins: 'Plugins',
  motdTab: 'MOTD',
  rawTab: 'Raw',
  extract: 'Extract',
  extractingData: 'Extracting Data...',
  extractionSuccess: 'Success',
  extractionPartial: 'Partial',
  extractionError: 'Error',
  extractionComplete: 'Complete',
  serverOnline: 'Online',
  serverOffline: 'Offline',
  serverError: 'Error',
  copyAll: 'Copy All',
  downloadAll: 'Download All',
  noHistoryAvailable: 'No extraction history available',
  errorLoadingHistoryText: 'Error loading data extraction history',
  data: 'Data',
  idle: 'Idle',
  extractedData: 'Extracted Data',
  date: 'Date',

  // Bot Connection
  botConnectionModule: 'BOT CONNECTION MODULE',
  botConnectionDescription: 'Connect to a target server below to prepare for bot deployment. Basic server information will be verified upon connection.',
  botSelection: 'Bot Selection',
  botTypesAvailable: '3 types available',
  botSelectionNone: 'No bot types available',
  botSelectionNoTypes: 'No bot types',
  botNameOpBot: 'OP Bot',
  botNameCrashBot: 'Crash Bot',
  botNameAccountBot: 'Account Bot',
  botDescriptionOpBot: 'Gain operator privileges',
  botDescriptionCrashBot: 'Test server stability',
  botDescriptionAccountBot: 'Find account passwords',
  botSuccessRate: 'Success Rate:',
  botConfiguration: 'Configuration',
  botUsername: 'Bot Username',
  botUsernameRandom: 'Random Username',
  botUsernameCustom: 'Custom Username',
  botUsernamePremium: 'Premium Account',
  botEnterCustomUsername: 'Enter Custom Username',
  botEnterDesiredUsername: 'Enter desired username',
  botTargetUsername: 'Target Username',
  botEnterTargetUsername: 'Enter target account name',
  botAttackMethod: 'Attack Method',
  botAttackMethodConsole: 'Console Commands Exploit',
  botAttackMethodPlugin: 'Plugin Vulnerabilities',
  botAttackMethodSocial: 'Social Engineering',
  botAttackMethodPermission: 'Permissions Exploits',
  botAttackMethodAll: 'Try All Methods',
  botSkin: 'Bot Skin',
  botVersion: 'Minecraft Version',
  botVersionAuto: 'Auto-Detect',
  botBehavior: 'Bot Behavior',
  botBehaviorStealth: 'Stealth Mode (Low Detection)',
  botBehaviorAggressive: 'Aggressive Mode (Fast Attack)',
  botBehaviorMixed: 'Mixed Mode (Balanced)',
  botAntiBotBypass: 'Anti-Bot Bypass Method',
  botAntiBotBypassNone: 'None (Default)',
  botAntiBotBypassStealth: 'Basic Stealth Tactics',
  botAntiBotBypassProxy: 'Proxy Rotation',
  botAntiBotBypassHuman: 'Human-like Behavior Emulation',
  botAntiBotBypassAdvanced: 'Advanced Evasion Protocol',
  botAttempts: 'Number of Attempts',
  botDeployButton: 'Deploy {{botName}}',
  botDeploying: 'Deploying...',
  botDeploymentConsole: 'Deployment Console',
  botOpCommandCenter: 'Operator Command Center',
  botOpRequired: 'Locked - OP Required',
  botOpAddAdmin: 'Add Administrator',
  botOpAddAdminDesc: 'Add your own account as server administrator',
  botOpExtractData: 'Extract Data',
  botOpExtractDataDesc: 'Extract player data, configs, and databases',
  botOpInstallBackdoor: 'Install Backdoor',
  botOpInstallBackdoorDesc: 'Install persistent access to the server',
  botOpExecute: 'Execute',
  botOpAccessRequired: 'OP Access Required',
  botStrategyTips: 'Bot Strategy Tips',
  botStrategyTipsPro: 'Pro Tips',
  botStrategyTip1: 'Avoid Detection',
  botStrategyTip1Desc: 'Use stealth mode and avoid rapid commands. Most anti-bot plugins detect unusual behavior patterns. Space out your attempts for better results.',
  botStrategyTip2: 'Target Vulnerabilities',
  botStrategyTip2Desc: 'Older server versions (1.8-1.12) are more vulnerable to console command exploits. Check server version before deploying.',
  botStrategyTip3: 'Rotate Methods',
  botStrategyTip3Desc: 'If one method fails, try different exploit methods. Common plugin vulnerabilities include Essentials, PermissionsEx, and LuckPerms misconfigurations.',
  botPremiumFeatures: 'Professional Bot Features',
  botPremiumFeaturesVip: 'VIP Only',
  botPremiumFeature1: 'Advanced OP Exploits',
  botPremiumFeature1Desc: 'Premium users gain access to advanced exploits targeting specific server plugins and vulnerable permission systems.',
  botPremiumFeature2: 'Multi-Bot Deployment',
  botPremiumFeature2Desc: 'Deploy multiple bots simultaneously with different strategies to increase success rates dramatically.',
  botPremiumFeature3: 'Undetectable Mode',
  botPremiumFeature3Desc: 'Professional bots use advanced techniques to avoid detection from popular anti-bot plugins.',
  botUpgradeToPremium: 'Upgrade to Professional',
  botDeploymentHistory: 'Bot Deployment History',
  botDeploymentHistoryLoading: 'Loading history...',
  botDeploymentHistoryError: 'Error loading history:',
  botDeploymentHistoryEmpty: 'No deployment history available',
  botDeploymentHistoryRecords: '{{count}} records',
  botDeploymentDate: 'Date & Time',
  botDeploymentServer: 'Server',
  botDeploymentType: 'Bot Type',
  botDeploymentResult: 'Result',
  botDeploymentActions: 'Actions',
  botDeploymentViewLog: 'View Log',
  botDeploymentOpBot: 'OP Bot',
  botDeploymentCrashBot: 'Crash Bot',
  botDeploymentAccountBot: 'Account Bot',

  // Common terms
  status: 'Status',
  connection: 'Connection',
  active: 'Active',
  ready: 'Ready',
  waiting: 'Waiting',
  achieved: 'Achieved',
  trying: 'Trying',
  save: 'Save',
  stop: 'Stop',
  copiedToClipboard: 'Copied to clipboard!',
  failedToCopyLog: 'Failed to copy log.',
  bots: 'Bots',

  // Payment Modal
  selectPaymentMethod: 'Select Payment Method',
  initiatingPayment: 'Initiating Payment...',
  awaitingPaymentConfirmation: 'Awaiting Payment Confirmation',
  paymentError: 'Payment Error',
  paymentSuccessful: 'Payment Successful',
  payment: 'Payment',
  renew: 'Renew',
  plan: 'Plan',
  upgradeTo: 'Upgrade to',
  currentPlan: 'Current Plan',
  paymentConfirmed: 'Payment Confirmed!',
  your: 'Your',
  planIsActive: 'plan is now active.',
  joinOurCommunity: 'Join our community for updates and support!',
  stayUpdated: 'Stay updated with the latest features and get help from our team',
  done: 'Done',
  securePaymentGateway: 'Secure Payment Gateway',
  noPaymentMethodsAvailable: 'No payment methods available.',
  byProceedingWithPayment: 'By proceeding with payment, you agree to our',
  confirmWith: 'Confirm with',
  selectedMethod: 'Selected Method',
  preparingYourPayment: 'Preparing Your Payment...',
  pleaseWaitWhileWeConnect: 'Please wait while we connect to the payment provider.',
  waitingForPaymentConfirmation: 'Waiting for Payment Confirmation',
  yourPaymentPageShouldHaveOpened: 'Your payment page should have opened in a new tab. This window will update automatically once confirmed.',
  reopenPaymentPage: 'Re-open payment page',
  needHelpContactUs: 'Need help? Contact us:',
  anUnexpectedErrorOccurred: 'An unexpected error occurred.',

  // Zero Day Method
  zeroDayMethodModule: 'ZERO-DAY METHOD MODULE',
  zeroDayMethodTitle: 'Proprietary Zero-Day Method',
  zeroDayMethodDescription: 'Our advanced proprietary technique uses undisclosed zero-day exploits with a 78% success rate on vulnerable servers. This method is constantly updated to stay ahead of security patches.',
  zeroDayPremiumExclusive: 'PROFESSINAL EXCLUSIVE',
  zeroDayUndetectable: 'Undetectable',
  zeroDayFastExecution: 'Fast Execution',
  zeroDayFullAccess: 'Full Access',
  zeroDayWeeklyUpdates: 'Weekly Updates',
  zeroDayAiConfiguration: 'AI Configuration',
  zeroDayAiAnalysisDepth: 'AI Analysis Depth',
  zeroDayBasic: 'Basic',
  zeroDayStandard: 'Standard',
  zeroDayDeep: 'Deep',
  zeroDayAnalysisFocus: 'Analysis Focus',
  zeroDayBalancedAnalysis: 'Balanced Analysis',
  zeroDayPluginVulnerabilities: 'Plugin Vulnerabilities',
  zeroDayConfigurationIssues: 'Configuration Issues',
  zeroDayNetworkSecurity: 'Network Security',
  zeroDayAuthenticationSystems: 'Authentication Systems',
  zeroDayAiModel: 'AI Model',
  zeroDayConnectionType: 'Connection Type',
  zeroDayDirectConnection: 'Direct Connection',
  zeroDayProxyChain: 'Through Proxy Chain',
  zeroDayVpnConnection: 'VPN Connection',
  zeroDayStealthMode: 'Stealth Mode',
  zeroDayAiPerformance: 'AI Performance',
  zeroDaySuccessRate: 'Success Rate',
  zeroDayDetectionRisk: 'Detection Risk',
  zeroDayAvgAnalysisTime: 'Avg Analysis Time',
  zeroDayModelVersion: 'Model Version',
  zeroDayCapabilities: 'Capabilities',
  zeroDayPluginAnalysis: 'Plugin Analysis',
  zeroDayConfigScanning: 'Config Scanning',
  zeroDayVersionDetection: 'Version Detection',
  zeroDayExploitMatching: 'Exploit Matching',
  zeroDayAdaptiveLearning: 'Adaptive Learning',
  zeroDayReportGeneration: 'Report Generation',
  zeroDayNetworkPathAnalysis: 'Network Path Analysis',
  zeroDayUserBehaviorSimulation: 'User Behavior Simulation',
  zeroDayAiProgress: 'AI Progress',
  zeroDayOverallProgress: 'Overall Progress',
  zeroDayCurrentTask: 'Current Task',
  zeroDayAwaitingInitialization: 'Awaiting Initialization',
  zeroDayConnectToServer: 'Connect to a server and start analysis.',
  zeroDayReadyForAnalysis: 'Ready for Analysis',
  zeroDayConfigureAi: 'Configure AI and start the process.',
  zeroDayAiOperationLog: 'Zero-Day AI Operation Log',
  zeroDayStartChat: 'Start',
  zeroDayHello: 'Hello',
  zeroDayAiThinking: 'AI is thinking...',
  zeroDayStopOrAsk: 'Stop or ask',
  zeroDayInputPlaceholder: 'Enter command for analysis...',
  zeroDayStopAnalysis: 'Stop Analysis',
  zeroDayStartAiAnalysis: 'Start AI Analysis',
  zeroDayStopping: 'Stopping...',
  zeroDayInitiating: 'Initiating...',
  zeroDayAnalysisComplete: 'Analysis Complete',
  zeroDayAiAchievedRconAccess: 'AI Achieved RCON Access!',
  zeroDayLiveControl: 'Live Control',
  zeroDayRconSuccessMessage: 'The Zero-Day AI has successfully gained RCON access to',
  zeroDayConsoleNowActive: 'The console above is now active for command execution.',
  zeroDayViewFullReport: 'View Full Report',
  zeroDayAiReport: 'Zero-Day AI Report',
  zeroDayOverallAssessment: 'Overall Assessment',
  zeroDayTargetServer: 'Target Server',
  zeroDayAnalysisReport: 'Analysis Report',
  zeroDayVulnerabilitiesFound: 'Vulnerabilities Found',
  zeroDayExploitMatching: 'Exploitation Paths',
  zeroDayRiskLevel: 'Risk Level',
  zeroDayRecommendations: 'Recommendations',
  zeroDayCritical: 'Critical',
  zeroDayHigh: 'High',
  zeroDayMedium: 'Medium',
  zeroDayLow: 'Low',
  zeroDayInformational: 'Informational',
  zeroDayClose: 'Close',
  zeroDayExportReport: 'Export Report',
  zeroDayRconActive: 'RCON Active',
  zeroDayCompletedReport: 'Completed Report',
  zeroDayError: 'Error',
  zeroDayConfiguringAi: 'Configuring AI',
  zeroDayIdle: 'Idle',
  zeroDayAnalyzing: 'Analyzing',
  zeroDayStoppingAnalysis: 'Stopping Analysis',
  zeroDayReadyToAnalyze: 'Ready to analyze.',
  zeroDayAiAnalysisInitiated: 'AI analysis initiated...',
  zeroDayCannotStartNotConnected: 'Cannot start: Not connected to a target server.',
  zeroDayCannotStartAlreadyRunning: 'Cannot start: An AI operation is already in progress.',
  zeroDayCannotStopNotRunning: 'Cannot stop: No analysis running or WebSocket disconnected.',
  zeroDayRconNotActive: 'RCON is not active.',
  zeroDayWebSocketNotConnected: 'WebSocket not connected. Please wait or refresh the page.',
  zeroDayServerNotConnected: 'Server not connected or is offline.',
  zeroDayOperationInterrupted: 'WebSocket connection lost. Current operation might be interrupted. Attempting to restore state...',
  zeroDayStateReceivedNoOperation: 'State received: No active AI operation. Ready to configure for',
  zeroDayStateReceivedNoServer: 'State update: Not connected to any server for ZeroDay AI.',
  zeroDayReconnectedToRcon: 'Reconnected to active RCON session.',
  zeroDayReconnectedToAnalysis: 'Reconnected to ongoing AI analysis.',
  zeroDayProgressDataMissing: 'Progress data missing in CURRENT_STATE from backend for active operation. Awaiting next update.',
  zeroDayReportSummary: 'Report Summary',
  zeroDayRconAccessGranted: 'RCON Access Granted',
  zeroDayReportGenerated: 'Report generated.',
  zeroDayInitializingAi: 'Initializing analysis core...',
  zeroDayInitiatingDeepScan: 'Initiating deep scan...',
  zeroDayOperationStatus: 'Operation Status',
  zeroDayUnknownErrorStructure: 'Unknown ZeroDay error structure.',
  zeroDayErrorOccurred: 'Error Occurred',
  zeroDayConnectToServerForAnalysis: 'Connect to server for analysis.',
  zeroDayReadyForAiAnalysis: 'Ready for AI analysis.',
  zeroDayAiActive: 'AI Active',
  zeroDayBetaNotice: 'This is a Beta version of ZeroDay Assist. We are constantly working on improving the algorithms.',
  zeroDayPossibleErrors: 'There may be errors',
  zeroDayReportBug: 'Found a bug?',
  zeroDayQueueTitle: 'Beta Test Limit',
  zeroDayQueueDesc: 'Currently, many people are using the AI. To maintain stability during the beta test, access is limited. Please wait 5-10 minutes for a slot to become available.',

  // Server Info Card
  serverInfoEnterIp: 'Enter Server IP to Connect',
  serverAlreadyBlacklisted: 'This server is already in the blacklist',
  serverInfoIpPlaceholder: 'Enter server IP (e.g., play.hypixel.net:25565)',
  serverInfoConnect: 'Connect to Server',
  serverInfoLoginToConnect: 'Login to Connect',
  serverInfoDisconnect: 'Disconnect',
  serverInfoOnline: 'Online',
  serverInfoOffline: 'Offline',
  serverInfoMotd: 'Message of the Day',
  serverBlacklisted: 'Server Blacklisted',
  serverBlacklistedDesc: 'This server has been added to the blacklist and cannot be tested.',
  reason: 'Reason',

  // Server Protection
  serverProtection: 'Server Protection',
  serverProtectionDescription: 'Protect your server from hacking with our comprehensive security toolset',
  protectionFeatures: 'Protection Features',
  antiBotProtection: 'Anti-Bot Protection',
  antiBotProtectionDesc: 'Advanced bot detection and blocking systems',
  ddosProtection: 'DDoS Protection',
  ddosProtectionDesc: 'Powerful DDoS attack mitigation mechanisms',
  rconProtection: 'RCON Protection',
  rconProtectionDesc: 'Secure remote console access protection methods',
  accountSecurity: 'Account Security',
  accountSecurityDesc: 'Account protection against brute-force and leaks',
  vulnerabilityScanning: 'Vulnerability Scanning',
  vulnerabilityScanningDesc: 'Regular scanning to identify and fix vulnerabilities',
  protectionPlans: 'Protection Plans',
  basicProtection: 'Basic Protection',
  basicProtectionDesc: 'Essential protection features for small servers',
  advancedProtection: 'Advanced Protection',
  advancedProtectionDesc: 'Enhanced protection features for medium servers',
  enterpriseProtection: 'Enterprise Protection',
  enterpriseProtectionDesc: 'Full protection suite for large servers',
  getStarted: 'Get Started',
  learnMore: 'Learn More',

  // Server Protection Component
  protectYourServer: 'Protect your server from unauthorized access',
  serverIpAddress: 'Server IP Address',
  addToBlacklist: 'Add to Blacklist',
  loginToProtect: 'Login to Protect',
  adding: 'Adding...',
  successTitle: 'Success!',
  serverProtected: 'Your server has been added to the protection list',
  whyProtectServer: 'Why protect your server?',
  protectionDescription: 'Adding your server to our blacklist prevents our tools from being used against it. This is especially important for servers you own or manage.',
  pleaseEnterServerIp: 'Please enter a server IP address',
  failedToAddServer: 'Failed to add server to blacklist',
  serverAlreadyBlacklisted: 'This server is already in the blacklist',

  partner: "Anchor Studio",
  partnerName: "Custom builds, plugins, games, textures, skins, add-ons",
  anchorStudioDesc: "Click to learn more!",

  // Monitoring Parser
  parserModuleTitle: 'SERVERS PARSER MODULE',
  parserMonitoring: 'Servers',
  parserParser: 'Parser',
  parserDescription: 'Analyze popular server monitoring sites to find vulnerable servers or servers with specific parameters.',
  parserConfiguration: 'Configuration',
  parserSearchType: 'Search Type',
  parserByVulnerability: 'By Vulnerability',
  parserByParameters: 'By Parameters',
  parserVulnerabilityLevel: 'Vulnerability Level',
  parserLowVulnerability: 'Servers with suspected Low Vulnerability',
  parserMediumVulnerability: 'Servers with suspected Medium Vulnerability',
  parserHighVulnerability: 'Servers with suspected High Vulnerability',
  parserLowVulnDesc: 'Servers with basic vulnerabilities',
  parserMediumVulnDesc: 'Servers with moderate vulnerabilities',
  parserHighVulnDesc: 'Servers with critical vulnerabilities',
  parserOnlinePlayersRange: 'Online Players Range',
  parserMin: 'Min',
  parserMax: 'Max',
  parserVersionFilter: 'Version Filter',
  parserVersionPlaceholder: '1.12.2, 1.16.5, etc.',
  parserVersionHint: 'Leave empty for all versions',
  parserServerCount: 'Server Count',
  parserServersFound: 'servers found',
  parserStartParsing: 'Start Parsing',
  parserStopParsing: 'Stop Parsing',
  parserParsing: 'Parsing...',
  parserProcessLog: 'Parser Process Log',
  parserClearLog: 'Clear Log',
  parserExport: 'Export',
  parserFoundServers: 'Found Servers',
  parserResults: 'results',
  parserSelectAll: 'Select All',
  parserDeselectAll: 'Deselect All',
  parserSelect: 'Select',
  parserServerIP: 'Server IP',
  parserVersion: 'Version',
  parserOnline: 'Online',
  parserVulnerability: 'Vulnerability',
  parserActions: 'Actions',
  parserCopy: 'Copy',
  parserViewDetails: 'View Details',
  parserMOTD: 'Message of the Day',
  parserFoundAt: 'Found At',
  parserFavicon: 'Favicon',
  parserNoServersYet: 'No servers found yet',
  parserTips: 'Parser Tips',
  parserSearchStrategies: 'Search Strategies',
  parserSearchStrategiesTip: 'Searching by vulnerability finds servers with known security issues, while searching by parameters allows you to find servers with specific characteristics.',
  parserVulnerabilityLevels: 'Vulnerability Levels',
  parserVulnerabilityLevelsTip: 'Low level finds servers with basic vulnerabilities, medium finds servers with more serious issues, and high finds servers with critical vulnerabilities.',
  parserUseFilters: 'Use Filters',
  parserUseFiltersTip: 'Filters for player count and server version help narrow down your search to the servers you want.',
  parserServerFound: 'Server found',
  parserParsingStarted: 'Parsing started',
  parserSearching: 'Searching',
  parserParsingCompleted: 'Parsing completed',
  parserFound: 'Found',
  parserCompleted: 'Completed',
  parserParsingStopped: 'Parsing stopped',
  parserStopped: 'Stopped',
  parserError: 'Parser Error',
  parserWebSocketNotConnected: 'WebSocket not connected. Please wait or refresh the page.',
  parserConnectionError: 'Connection Error',
  parserAlreadyRunning: 'Parser already running',
  parserInitiating: 'Initiating',
  parserNoActiveProcess: 'No active process',
  parserStoppingProcess: 'Stopping process',
  parserStopping: 'Stopping',
  parserNoData: 'No Data',
  parserNoServersToExport: 'No servers to export',
  parserExportSuccess: 'Export Successful',
  parserExported: 'Exported',

  monitoringParser: "Servers parser",
  parserShort: "Parser",
  monitoringParserDescription: "Automated search for servers from monitors based on vulnerability and online parameters",
  parserMonitorings: "Monitors",
  parserServersAvailable: "Servers available",

  parserNewFeature: '🎉 New Feature',
  parserPromoTitle: 'Try our new',
  parserPromoTitleHighlight: 'Servers Parser',
  parserPromoDescription: 'Automatically find vulnerable servers from 50+ monitorings. Over 100,000 servers available for analysis!',
  parserPromoFeature1: '50+ monitorings',
  parserPromoFeature2: '100K+ servers',
  parserPromoFeature3: 'Auto-filtering',
  parserPromoButton: 'Try Free',
  parserMonitorings: 'monitorings',
  parserServers: 'servers',

  // Delayed Support Message
  supportMessageTitle: 'Delays or difficulties?',
  supportMessageText: 'Contact us for assistance',
  supportMessageDescription: 'If you\'re experiencing payment issues or have questions, our support team is ready to help.',

  autumnSale: "Autumn Sale",
  newYearSale: "New Year Sale",
  saleEndsIn: "Christmas in",
  days: "Days",
  hours: "Hours",
  min: "Min",
  sec: "Sec",
  withAutumnDiscount: "with Autumn Discount",
  withNewYearDiscount: "with New Year Discount",
  discount: "Discount",
  unlimitedAccess: "Unlimited Access",
  prioritySupport: "Priority Support",
  advancedTools: "Advanced Tools",
  specialSale: "Special Sale",
  winterSale: "Winter Sale",
  summerSale: "Summer Sale",
  springSale: "Spring Sale",
  blackFridaySale: "Black Friday Sale",
  cyberMondaySale: "Cyber Monday Sale",

  otherPaymentMethods: 'Other Payment Methods',
  cryptoBankEtc: 'Crypto, bank transfer, etc.',
  otherPaymentMethodsDescription: 'Contact our support team to use alternative payment methods',
  contactViaDiscord: 'Contact via Discord',
  contactViaTelegram: 'Contact via Telegram',
  alternativePaymentInfo: 'We support various payment methods',
  cryptoCurrency: 'Cryptocurrency',
  bankTransfer: 'Bank Transfer',
  otherMethods: 'Other Methods',
  backToPaymentMethods: 'Back to Payment Methods',
  // Maintenance Modal
  maintenanceMode: 'Maintenance Mode',
  methodAvailableSoon: 'The method will be available soon',
  maintenanceDescription: 'This feature is undergoing scheduled maintenance to improve performance and stability.',
  expected: 'Expected',
  thisMonth: 'This month',
  status: 'Status',
  updating: 'Updating',
  stayUpdated: 'Stay updated via our channels',
  understood: 'Understood',
  botCommandHelpTitle: 'Available commands:',
  botCommandHelpGoto: '- "goto <world>" (e.g. goto survival) to navigate',
  botCommandHelpStart: '- "start" to begin the automated testing sequence',

  // Modals & Reminders
  upsellRequired: 'Upgrade Required',
  featureRequiresPlan: '**We would love to provide you with this feature for free, but however...** This feature requires the {{plan}} plan or higher. Please upgrade your subscription to access this tool.',
  upgradePlan: 'Upgrade Plan',
  premiumFeature: 'Premium Feature',
  secretMethodExclusive: 'The Secret Method is available exclusively for Premium and VIP users. Upgrade your plan to unlock the most powerful security assessment tool in our arsenal.',
  upgradeToVipForAll: 'Upgrade to VIP for All Features',

  'perm_module_rconbrute': 'RCON Audit Access',
  'perm_module_rconbrute_speed': 'RCON Multi-threaded Scanning',
  'perm_permission_rcon_speed': 'Increased RCON Scanning Speed',
  'perm_module_parser_high': 'Access to critical vulnerabilities in Parser',
  'perm_module_accountchecker': 'Account Checker Usage',

  // AI Assistant
  aiAssistantTitle: 'Hacker Assistant',
  aiAssistantPlaceholder: 'Ask a question about hacking or defense...',
  aiAssistantWelcome: 'Hi! I am your AI mentor. How can I help with security auditing today?',
  aiAssistantInvite: 'Need help with server audit? I\'ll help you find the right tool!',
  aiAssistantConnecting: 'Connecting to neural network...',
  aiAssistantError: 'AI communication error. Try again later.',
  aiAssistantInsufficientPlan: 'Your current plan does not support the AI Assistant.',
  aiAssistantLoginRequired: 'Please login to your account to use the AI Assistant.',
  ERROR_RATE_LIMIT_EXCEEDED: 'Rate limit exceeded (10/min). Please wait.',
  ERROR_AI_BANNED: 'Your account is temporarily blocked in the AI module for spamming requests.',
  ERROR_AI_SERVICE_UNAVAILABLE: 'AI service is temporarily unavailable.',

  // New Feature Modal
  newFeatureTitle: 'ZERO-DAY METHOD DETECTED',
  newFeatureDescription: 'Our systems have intercepted a critical vulnerability in Minecraft security protocols. A new proprietary Zero-Day method is now available with a 78% success rate. Vulnerability analysis is now automated with next-gen AI.',
  newFeatureTryBtn: 'GET ACCESS',
  newFeatureUpdateTitle: 'System Update',
  newFeatureUpdateDesc: 'We have implemented an advanced analysis algorithm that bypasses modern protection systems. Use the AI Assistant to find attack vectors.',

  // AI Assistant Improvements
  aiAssistantSlowResponse: 'High load on the neural network. Response may take longer...',
  aiAssistantCharLimit: 'Message too long. Max 5000 characters.',
  aiAssistantSendHint: 'Ctrl + Enter to send',
  aiAssistantPlaceholder: 'Describe the task or issue...',
  aiAssistantTitle: 'Hacker Assistant',
  aiAssistantDisclaimer: 'Hacker can be wrong. Check the info.',
  aiAssistantInviteRcon: 'Need help analyzing RCON logs?',
  aiAssistantInviteBots: 'Bot finished working. Any questions about the results?',
  aiAssistantInviteDdos: 'Attack stopped. Want to discuss server protection?',
  aiAssistantInviteParser: 'Parsing complete. Want to find vulnerabilities in these servers?',
  aiAssistantInviteData: 'Data extracted. Shall we look for entry points?',
  aiAssistantInviteAccounts: 'Account check complete. Need help analyzing the results?',

  // Minigames
  topPlayers: 'TOP Players',
  score: 'Score',
  rank: 'Rank',
  player: 'Player',
  highScore: 'High Score',
  newRecord: 'New Record!',
  loadingLeaderboard: 'Loading leaderboard...',
  failedToLoadLeaderboard: 'Failed to load TOP',
};

export default en;
